import { createSelector } from 'reselect';
import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
export const getPaneState = basicSelector(state => state.paneState);
export const getShouldShowCustomReplyWarning = createSelector(getPaneState, paneState => paneState.showCustomReplyAddressWarning);
export const getSelectedScrollableElementId = createSelector(getPaneState, paneState => paneState.selectedElement);